import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { NgChartsModule } from 'ng2-charts';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';
import { OffboardingCardComponent } from './cwr-offboardingCard/offboarding-card/offboarding-card.component';
import { AddCommentsRenderer } from './add-comments-renderer.component';
import { StatusRenderer } from './status-renderer.component';
import { StatusLabelComponent } from '@app/shared/components/Status-Label/status-label.component';
import { AssetManagementRoutingModule } from './asset-management-routing.module';
import { GraphComponent } from '@app/shared/components/graph/graph.component';
import { VendorStatsCardComponent } from './vendor-stats/vendor-stats-card/vendor-stats-card.component';
import { AssetManagementDashboardComponent } from './asset-management-dashboard/asset-management-dashboard.component';
import { InventoryComponent } from './inventory/inventory.component';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { DateRangeComponent } from '@app/shared/components/date-range/date-range.component';
import { DropdownComponent } from '@app/shared/components/dropdown/dropdown.component';
import { AssetAllocatedComponent } from './asset-allocated/asset-allocated.component';
import { SearchFieldComponent } from '@app/shared/components/search-field/search-field.component';
import { InventoryFormsComponent } from './inventory/inventory-forms/inventory-forms.component';
import { MyRequestFormComponent } from './my-request/my-request-form/my-request-form.component';
import { AssetManagementTableComponent } from './asset-management-table/asset-management-table.component';
import { DamageAnalyticsFormComponent } from './damage-analytics/damage-analytics-form/damage-analytics-form.component';
import { AddCommentsComponent } from './cwr-offboardingCard/Offboarding-DetailsScreen/add-comments/add-comments.component';
import { ViewCommentsComponent } from './cwr-offboardingCard/Offboarding-DetailsScreen/view-comments/view-comments.component';
import { UpcomingOnboardingCardComponent } from './upcoming-onboarding-card/upcoming-onboarding-card.component';
import { DamageAnalyticsCardComponent } from './damage-analytics/damage-analytics-card/damage-analytics-card.component';
import { AddNewAssetFormComponent } from './asset-allocated/add-new-asset-form/add-new-asset-form.component';

@NgModule({
  declarations: [
    AssetManagementDashboardComponent,
    AssetAllocatedComponent,
    InventoryComponent,
    InventoryFormsComponent,
    MyRequestFormComponent,
    AssetManagementTableComponent,
    DamageAnalyticsFormComponent,
    OffboardingCardComponent,
    AddCommentsComponent,
    VendorStatsCardComponent,
    UpcomingOnboardingCardComponent,
    DamageAnalyticsCardComponent,
    AddNewAssetFormComponent,
    AddCommentsRenderer,
    StatusRenderer,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AssetManagementRoutingModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatCardModule,
    MatRadioModule,
    EmeraldDatepickerModule,
    NgChartsModule,
    AgGridModule,
    SharedModule,
    StatusLabelComponent,
    SearchFieldComponent,
    DropdownComponent,
    GraphComponent,
    FileUploadComponent,
    DateRangeComponent,
    ViewCommentsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssetManagementModule {}
